import { ChainId } from '@pancakeswap/sdk'
import { MAINNET_ADDRESSES, TESTNET_ADDRESSES } from '@pancakeswap/address-config'

export const FARM_AUCTION_HOSTING_IN_SECONDS = 691200

export const masterChefAddresses = {
  [ChainId.MANTLE]: '',
  [ChainId.MANTLE_TESTNET]: '',
} as const

export const masterChefV3Addresses = {
  // [ChainId.ETHEREUM]: '0x556B9306565093C855AEA9AE92A594704c2Cd59e',
  // [ChainId.GOERLI]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.MANTLE]: MAINNET_ADDRESSES.MasterChef,
  [ChainId.MANTLE_TESTNET]: TESTNET_ADDRESSES.MasterChef,
} as const satisfies Record<ChainId, string>

export const nonBSCVaultAddresses = {
  // [ChainId.ETHEREUM]: '0x2e71B2688019ebdFDdE5A45e6921aaebb15b25fb',
  // [ChainId.GOERLI]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
} as const
